module.exports = __webpack_public_path__ + "img/trig_clip.0ff22c18.gif";